import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessageField from 'components/field/MessageField/ErrorMessageField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const UserNotActiveNotification = (props) => {
    const {
        data,
        resource,
        translate,
    } = props;

    if (utils.isEmpty(data)) {
        return null;
    }

    if (!data.is_confirmed || data.is_enabled) {
        return null;
    }

    return (
        <ErrorMessageField>
            { translate(`resources.${ resource }.notifications.inactive`) }
        </ErrorMessageField>
    );
};

UserNotActiveNotification.propTypes = {
    data: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(UserNotActiveNotification);



// WEBPACK FOOTER //
// ./src/components/notifications/UserNotActiveNotification.js